module.exports = __webpack_public_path__ + "img/logo-icon-white.9a92f97d.png";